import type { MailAccountSummary } from "@/lib/types/mail";

/** Tri par sort_order serveur (fallback e-mail). */
export function sortAccountsBySortOrder(accounts: MailAccountSummary[]): MailAccountSummary[] {
  return [...accounts].sort((a, b) => {
    const ao = a.sortOrder ?? 0;
    const bo = b.sortOrder ?? 0;
    if (ao !== bo) return ao - bo;
    if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1;
    return a.email.localeCompare(b.email, undefined, { sensitivity: "base" });
  });
}

export function reorderAccountIds(
  order: number[],
  accountId: number,
  direction: "up" | "down"
): number[] {
  const index = order.indexOf(accountId);
  if (index < 0) return order;
  const swapIndex = direction === "up" ? index - 1 : index + 1;
  if (swapIndex < 0 || swapIndex >= order.length) return order;
  const next = [...order];
  [next[index], next[swapIndex]] = [next[swapIndex], next[index]];
  return next;
}

export function applySortOrderToAccounts(
  accounts: MailAccountSummary[],
  orderedIds: number[]
): MailAccountSummary[] {
  const map = new Map(accounts.map((a) => [a.id, a]));
  const next: MailAccountSummary[] = [];
  for (let index = 0; index < orderedIds.length; index++) {
    const account = map.get(orderedIds[index]!);
    if (account) {
      next.push({ ...account, sortOrder: index });
    }
  }
  return next.length === accounts.length ? next : accounts;
}
